import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_STAGES_PROGRESS_WITH_WORKS].GET_REPORTS_STAGES_PROGRESS_WITH_WORKS]: {
		url: '/company/:companyId/reports/stages/progress_with_works/',
	},
}
